<template>
  <div>
    <div>
      <div
        v-if="despacho.codigo && estados.codigo"
        class="grid grid-cols-5 gap-4"
      >
        <div>
          <p>N° Despacho</p>
        </div>
        <div class="text-right font-bold uppercase col-span-3">
          <p>{{ despacho.codigo ?? "-" }}</p>
        </div>
      </div>

      <div
        v-if="despacho.fecha_inicio && estados.fecha_inicio"
        class="grid grid-cols-5 gap-4"
      >
        <div>
          <p>Fecha Inicial</p>
        </div>
        <div class="text-right font-bold uppercase col-span-3">
          <p>
            {{
              despacho.fecha_inicio
                ? moment(despacho.fecha_inicio).format("DD-MM-YYYY")
                : "-"
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import axios from "axios";
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  emits: ["update-arrival-date"],
  data() {
    return {
      nombre: "",
      codigo: "",
      ref_cliente: "",
      fecha_inicio: "",
      pantalla: false,

      showEditEffectiveArrivalDate: false,
      arrivalDate: "",

      showSuccess: false,
      showError: false,
    };
  },
  mounted() {
    if (screen.width <= 660) this.pantalla = false;
    else this.pantalla = true;

    this.arrivalDate = this.despacho.fecha_efectiva_arribo;
  },
};
</script>
